
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/introduction/roadmap",
      function () {
        return require("private-next-pages/x/introduction/roadmap.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/introduction/roadmap"])
      });
    }
  